import styled from 'styled-components';
import {
    robotoRegular,
    scarpaGray100,
    scarpaGray500,
    scarpaGray800,
    spanishViridian25,
    spanishViridian500,
} from '@habitech/shared';
import { Wrapper } from '../calculo-sugeridos/styles';

/**
 * Raíz de la sección de Vigencias: reusa el Wrapper compartido pero aplica la
 * tipografía Roboto (igual que el carrito comercial, asignaciones y slots). La
 * fuente se hereda, así que con fijarla en la raíz basta para que toda la sección
 * (incluida la tabla de slots) use Roboto; los íconos (pcom-icon) conservan su
 * propia fuente porque la definen vía su clase.
 */
export const ValiditiesRoot = styled(Wrapper)`
    font-family: ${robotoRegular};
`;

export const Intro = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 14px;
    border-radius: 10px;
    background: ${spanishViridian25};
    border: 1px solid ${spanishViridian500};
    color: ${spanishViridian500};
    font-family: ${robotoRegular};
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 16px;
`;

export const FormRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    align-items: flex-start;
    margin-bottom: 16px;

    > * {
        flex: 1 1 220px;
        min-width: 220px;
    }
`;

export const Field = styled.label`
    display: flex;
    flex-direction: column;
    gap: 6px;
    font-family: ${robotoRegular};
    font-size: 14px;
    font-weight: 600;
    color: ${scarpaGray800};

    input,
    textarea {
        font-family: ${robotoRegular};
        font-size: 14px;
        font-weight: 400;
        color: ${scarpaGray800};
        padding: 10px 12px;
        border: 1px solid ${scarpaGray100};
        border-radius: 8px;
        background: white;
        outline: none;
        transition: border-color 0.15s ease;

        &:focus {
            border-color: ${spanishViridian500};
        }
    }

    textarea {
        resize: vertical;
        min-height: 42px;
    }
`;

export const LoadingBar = styled.div`
    position: relative;
    height: 3px;
    width: 100%;
    border-radius: 2px;
    background: ${spanishViridian25};
    overflow: hidden;
    margin-bottom: 12px;

    &::after {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        width: 40%;
        background: ${spanishViridian500};
        border-radius: 2px;
        animation: validity-loading-slide 1.1s infinite ease-in-out;
    }

    @keyframes validity-loading-slide {
        0% {
            left: -40%;
        }
        100% {
            left: 100%;
        }
    }
`;

export const TableArea = styled.div<{ $loading?: boolean }>`
    transition: opacity 0.2s ease;
    opacity: ${({ $loading }) => ($loading ? 0.5 : 1)};
    pointer-events: ${({ $loading }) => ($loading ? 'none' : 'auto')};
`;

export const SelectionHint = styled.div`
    font-family: ${robotoRegular};
    font-size: 12px;
    color: ${scarpaGray500};
    margin: 8px 0 16px;
`;

export const TableToolbar = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    gap: 12px;
    margin-bottom: 12px;
`;

export const SlotSearchField = styled.label`
    display: flex;
    flex-direction: column;
    gap: 6px;
    font-family: ${robotoRegular};
    font-size: 14px;
    font-weight: 600;
    color: ${scarpaGray800};

    input {
        font-family: ${robotoRegular};
        font-size: 14px;
        font-weight: 400;
        color: ${scarpaGray800};
        padding: 10px 12px;
        border: 1px solid ${scarpaGray100};
        border-radius: 8px;
        background: white;
        outline: none;
        min-width: 220px;
        transition: border-color 0.15s ease;

        &:focus {
            border-color: ${spanishViridian500};
        }
    }
`;

/**
 * Pie de la tabla de slots: centra el paginador (reusa el de Asignaciones, que
 * ya incluye el selector "Mostrar N" + rango + navegación de páginas).
 */
export const TableFooter = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 16px;
`;

export const Actions = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 16px;
`;

export const SaveError = styled.div`
    font-family: ${robotoRegular};
    color: #d32f2f;
    font-size: 13px;
    margin-top: 12px;
`;

export const SuccessModalContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 12px;
    padding: 16px 8px 8px;
    font-family: ${robotoRegular};

    .success-icon {
        color: ${spanishViridian500};
    }

    .success-title {
        font-size: 20px;
        font-weight: 700;
        color: ${spanishViridian500};
    }

    .success-subtitle {
        font-size: 14px;
        font-weight: 400;
        color: ${scarpaGray500};
    }
`;
